export const FETCH_ALL_SUBSCRIPTION = 'fetch_all_subscription';
export const FETCH_ALL_SUBSCRIPTION_SUCCESS = 'fetch_all_subscription_success';
export const EDIT_SUBSCRIPTION = 'edit_subscription';
export const DELETE_SUBSCRIPTION = 'delete_subscription';
export const CREATE_SUBSCRIPTION = 'create_subscription';
export const CREATE_SUBSCRIPTION_SUCCESS = 'create_subscription_success';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'update_subscription_success';
export const UPDATE_SUBSCRIPTION = 'update_subscription';
export const DELETE_SUBSCRIPTION_SUCCESS = 'delete_subscription_success';
export const SET_SUBSCRIPTION = 'set_subscription';
export const SET_ROLE = 'set_role';